const AccessControllers = require('./src/access-controllers')
module.exports = AccessControllers
